import React from 'react';
import { I18n } from 'react-redux-i18n';
import SelectWineVintage from 'components/Select/selectWineVintage';

import { RivalsByVintage } from 'interface/price';

const PriceSelectCompetitor = ({
  vintage,
  vintagesByWine,
  showVintages,
  competitor,
  competitorVintage,
  isMulti = false,
  onChangeCompetitor,
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  onChangeCompetitorVintage = (e) => {}
}: {
  vintage: string | null;
  vintagesByWine: RivalsByVintage;
  showVintages: boolean;
  competitor: string | null;
  competitorVintage?: string | null;
  isMulti?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChangeCompetitor: (e: string | null) => void;
  // eslint-disable-next-line no-unused-vars
  onChangeCompetitorVintage?: (e: string | null) => void;
}) => {
  // Format vintagesByWine to new format
  // If showVintage is false, no competitor comparaison
  const vintagesByWineNewFormat = Object.assign(
    {},
    ...Object.keys(vintagesByWine || {})
      .filter(
        (wineName) =>
          vintagesByWine[wineName] &&
          vintage &&
          vintagesByWine[wineName].includes(vintage)
      )
      .map((wineName) => ({
        [wineName]: {
          name: wineName,
          vintages: showVintages ? vintagesByWine[wineName] : [vintage]
        }
      }))
  );

  return (
    <div className="selectSetsContainer ignored-export">
      <SelectWineVintage
        onChange={(
          value: { id: string; name: string; vintage: string } | null
        ) => {
          onChangeCompetitor(value ? value.name : null);
          onChangeCompetitorVintage(value ? value.vintage : null);
        }}
        value={
          competitor
            ? {
                id: competitor,
                name: competitor,
                vintage: competitorVintage
              }
            : null
        }
        vintagesByWine={vintagesByWineNewFormat}
        showVintages={showVintages}
        placeholder={I18n.t('prices.placeholderRival')}
        isMulti={isMulti}
      />
    </div>
  );
};

export default PriceSelectCompetitor;
